import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export const ConfirmDeleteDialog = ({ open, onClose, onConfirm, title = "Delete Item", description = "Are you sure? This action cannot be undone." }) => (
  <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="sm:max-w-md dark:bg-slate-900 dark:border-slate-700" data-testid="confirm-delete-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 dark:text-slate-100">
          <AlertTriangle className="w-5 h-5 text-red-500" />
          {title}
        </DialogTitle>
        <DialogDescription className="dark:text-slate-400">{description}</DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2 sm:gap-0">
        <Button variant="outline" onClick={onClose} className="dark:border-slate-600 dark:text-slate-300" data-testid="confirm-delete-cancel">Cancel</Button>
        <Button onClick={() => { onConfirm(); onClose(); }} className="bg-red-600 hover:bg-red-700 text-white" data-testid="confirm-delete-ok">Delete</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
